<template>
    <FeaturesPageFeaturePanel icon="automatic" :title="$t('pages.features.automaticModeCard.title')"
                              :desc="$t('pages.features.automaticModeCard.desc')">
        <h2>
            {{$t('pages.features.automaticModeCard.funcTitle')}}
        </h2>
        <ul class="automaticFeaturesList">
            <li v-for="(i,index) in $t('pages.features.automaticModeCard.featuresList')" :key="index">
                <h3>{{i.title}}</h3>
                {{i.text}}
            </li>
        </ul>
        <div class="symbols-table">
            <div class="symbols-table-header">
                <h4 v-for="(i,index) in $t('pages.features.automaticModeCard.symbolsTable.headers')" :key="index">{{i}}</h4>
            </div>
            <p v-for="(i,index) in $t('pages.features.automaticModeCard.symbolsTable.body')" :key="index">{{i}}</p>
        </div>
    </FeaturesPageFeaturePanel>
</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";

    export default {
        name: "AutomaticModeFeature",
        components: {FeaturesPageFeaturePanel}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    h2 {
        font-weight: 300;
    }

    h3 {
        font-weight: 400;
    }

    ul > li {
        font-size: 0.9em;
        margin-top: 1em;
        margin-bottom: 0.5em;
        margin-left: 1em;
        margin-right: 1em;
        text-align: justify;
        font-weight: 300;
    }

    .symbols-table {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        margin-right: 1rem;
        margin-top: 1rem;
        border: 1px solid $text80;

        .symbols-table-header {
            grid-column: 1/5;
            grid-row: 1;
            background: $back20;
            display: grid;
            grid-template-columns: repeat(4, 1fr);

            h4 {
                padding-left: 0.5rem;
                padding-top: 0.2rem;
                padding-bottom: 0.2rem;
                padding-right: 0.5rem;
                text-align: start;
                height: 100%;
                width: 100%;
                border-right: 1px solid $text80;
                border-bottom: 1px solid $text80;
                font-weight: 400;
            }
        }

        p {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            padding-top: 0.2rem;
            padding-bottom: 0.2rem;
            height: 100%;
            width: 100%;
            border-right: 1px solid $text80;
            border-bottom: 1px solid $text80;
        }

    }
</style>